import {
  DataSources,
  Diligence,
  ImportedData,
  OtherData,
  OutcomeReasons,
  ReasonCodes,
  Tags,
  YourCustomer,
} from '../cards';
import { Col, Row } from '../common';
import { useEventTypeEvaluationsContext } from '../context';
import { hasReturnedReasonCodesData, hasDataSourcesData } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { useFetchedUserContext } from '~/helpers/hooks';

export const PersonUpdatedOverview = () => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const { feature_flags: featureFlags } = useFetchedUserContext();
  const hideEmptyCardsEnabled = !!featureFlags?.['remove-empty-cards'];

  return (
    <Row>
      <Col>
        <YourCustomer header="Customer Updates" />
        <ImportedData />
      </Col>
      <Col>
        <OutcomeReasons />
        <Tags />
        {shouldRenderCard(hasReturnedReasonCodesData(evaluation), hideEmptyCardsEnabled)
          && <ReasonCodes />}
        <Diligence />
        {shouldRenderCard(hasDataSourcesData(evaluation), hideEmptyCardsEnabled)
          && <DataSources />}
        <OtherData />
      </Col>
    </Row>
  );
};
